













import { FormElementTag } from '@/models/Form';
import { BNavbar, BNavbarNav, BNavText } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
    name: 'PreviewTools',
    components: {
        'b-navbar': BNavbar,
        'b-navbar-nav': BNavbarNav,
        'b-nav-text': BNavText,
    },
    computed: mapGetters(['tags', 'points']),
})
export default class PreviewTools extends Vue {}
